import { NavLink } from "react-router-dom";

const NavSaved = () => {
  return (
    <>
      <NavLink to="/saved">
        <p>Saved</p>
      </NavLink>
    </>
  );
};

export default NavSaved;
